import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import ExecutiveOverview from '../features/analytics/ExecutiveOverview';
import DailyIncomeChart from '../features/analytics/DailyIncomeChart';
import { listRestaurants, type RestaurantRecord } from '../services/restaurants';

const getRestaurantFilterLabel = (restaurant: RestaurantRecord) =>
  restaurant.district?.trim().length ? restaurant.district.trim() : restaurant.name;

export default function DailyIncomePage() {
  const [restaurantId, setRestaurantId] = useState('');

  const { data: restaurants = [] } = useQuery<RestaurantRecord[]>({
    queryKey: ['restaurants'],
    queryFn: listRestaurants,
  });

  const selectedRestaurantLabel = useMemo(() => {
    const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === restaurantId);
    return selectedRestaurant ? getRestaurantFilterLabel(selectedRestaurant) : null;
  }, [restaurantId, restaurants]);

  return (
    <div className="page">
      <header className="page-header analytics-page-header">
        <div>
          <h1>Günlük Gelir</h1>
          <p>Her restoran için gelir trendlerini takip ederek operasyonları optimize edin.</p>
        </div>
        <div className="form-field analytics-page-filter">
          <label htmlFor="daily-income-restaurant-filter">Şube</label>
          <select
            id="daily-income-restaurant-filter"
            value={restaurantId}
            onChange={(event) => setRestaurantId(event.target.value)}
          >
            <option value="">Tümü</option>
            {restaurants.map((restaurant) => (
              <option key={restaurant.id} value={restaurant.id}>
                {getRestaurantFilterLabel(restaurant)}
              </option>
            ))}
          </select>
        </div>
      </header>
      <section className="page-section">
        <ExecutiveOverview restaurantId={restaurantId || undefined} restaurantLabel={selectedRestaurantLabel} />
        <DailyIncomeChart restaurantId={restaurantId || undefined} restaurantLabel={selectedRestaurantLabel} />
      </section>
    </div>
  );
}
